import JQueryView, { on } from '../../../common/views/jqueryView';

// 特定投資家更新案内モーダルの × クリックで dismiss cookie をセットし、15分抑制する。
// （申請/辞退フローのページでの非表示はコントローラ側 RenewSpecificModalConcern で制御している）
// 規約再同意モーダル(policyReconsentModalView)と同じ仕組み・抑制期間とし、
// cookie 名のみ専用のものを使う。Max-Age=900 (15 分) で短い抑制とする。
// モーダル自体の close は Bootstrap の data-dismiss="modal" が担当する。
const DISMISS_MAX_AGE_SECONDS = 60 * 15; // 15 minutes

export default class RenewSpecificModalView extends JQueryView {
  constructor() {
    super('#apply_renew_specific_modal');
  }

  @on({ event: 'click', selector: '.js-renew-specific-dismiss' })
  onDismiss() {
    // HTTPS 配信時のみ Secure を付与。HTTP の dev 環境では Secure 付き cookie は保存されないため条件分岐する
    const secureAttr = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `renew_specific_modal_dismissed=1; path=/; Max-Age=${DISMISS_MAX_AGE_SECONDS}; SameSite=Lax${secureAttr}`;
  }
}
